<template>
    <div
        :class="{ 'opacity-50' : isDisabled }"
        class="flex items-center gap-2"
    >
        <input
            :id="checkboxId"
            ref="checkbox"
            type="checkbox"
            :checked="modelValue"
            @change="emitChange"
            :disabled="isDisabled"
            :class="{ 'cursor-not-allowed' : isDisabled }"
            class="rounded-sm border-2 border-black w-4 h-4 font-bold"
        >

        <label
            :for="checkboxId"
            class="text-sm font-light font-gotham"
        >
            <slot />
        </label>
    </div>
</template>

<script>
    export default {
        props: {
            checkboxId: {
                type: String,
                required: true,
            },

            modelValue: {
                type: Boolean,
                default: false,
            },

            isDisabled: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            emitChange() {
                this.$emit('update:modelValue', this.$refs.checkbox.checked);
                this.$emit('checkboxChecked', this.$refs.checkbox.checked);
            },
        },
    };
</script>
